export default __webpack_public_path__ + "static/media/repossession.877a6888.svg";